import {Mapper} from '@s-ui/domain'

export class RawParamsToGetInstantOfferRequestSellerMapper extends Mapper {
  constructor({config, getInstantOfferRequestFactory}) {
    super()

    this._config = config
    this._DEALER_TYPES = this._config.get('dealer').DEALER_TYPES
    this._getInstantOfferRequestFactory = getInstantOfferRequestFactory
  }

  map = requestFields => {
    const {
      bodyTypeDoors,
      email,
      fuelId,
      km,
      makeId,
      makeName,
      modelId,
      modelName,
      name,
      plate,
      phone,
      postalCode,
      transmissionTypeId,
      vehicleStatus,
      versionId,
      versionName,
      year
    } = requestFields

    return this._getInstantOfferRequestFactory({
      bodyTypeDoors,
      condition: vehicleStatus,
      dealerType: this._DEALER_TYPES.ALL,
      email,
      fuelId: Number(fuelId),
      makeId: Number(makeId),
      makeName,
      mileage: Number(km),
      modelId: Number(modelId),
      modelName,
      name,
      licensePlate: plate,
      phone,
      postalCode: String(postalCode).padStart(5, '0'),
      transmissionTypeId: Number(transmissionTypeId),
      versionId: Number(versionId),
      versionName,
      year: Number(year)
    })
  }
}
